const addRegisterForm = (insertBeforeElement) => {
  if (!document.querySelector(`[id^="loginDialog"]`)) {
    let loginDialog = document.createElement('div')
    loginDialog.id = 'loginDialog'
    insertBeforeElement.parentNode.insertBefore(loginDialog, insertBeforeElement)
  }
  tp.push([
    'init',
    function () {
      tp.pianoId.show({
        disableSignUp: false,
        displayMode: 'inline',
        containerSelector: '#loginDialog',
        screen: 'login',
        showCloseButton: false,

        loggedIn: function (data) {
          displayPinpoll()

          tp.experience.execute()
        },
        loggedOut: function () {},
        close: function () {},
        registrationSuccess: function (data) {
          let data_register_event = {
            event: 'register',
          }
          window.dataLayer.push(data_register_event)
        },
      })
    },
  ])
}

export default addRegisterForm
